export const CLOSED = "CLOSED";
export const OPEN = "OPEN";
export const OPENING = "OPENING";
export const SAVING = "SAVING";
export const RESETTING = "RESETTING";
